// Import Dependencies
import React from 'react';
import PropTypes from 'prop-types';

const PerformanceDetails = ({
  title, dates, performanceList,
}) => (
  <div className="c-performance">
    <div className="c-performance__content">
      <h2 className="u-heading-3">{title}</h2>
      <p className="u-bold-text  u-spacing-bottom-zero">
        Book your tickets:
        {dates}
      </p>
      <p>Select a date and time for the performance</p>
    </div>
    {(!performanceList || !performanceList.length)
      && <p>No performances found</p>}

    {performanceList
      && performanceList.length
      && (
        <ul className="c-performance__list">
          {performanceList.map((performance) => (
            <li className="c-performance__item" key={performance.venue}>
              <p className="u-bold-text">{performance.venue}</p>
              {performance.tickets.map((ticket) => (
                <div className="c-performance__tickets" key={`${performance.venue} ${ticket.date}`}>
                  <h3 className="u-heading-4  u-spacing-bottom-zero">{`${ticket.date}, ${ticket.time}`}</h3>
                  {(ticket.offSaleDateTime > 0 && (ticket.offSaleDateTime < Math.floor(Date.now() / 1000))) ? (
                    <a href={ticket.externalBookingLink} rel="noreferrer noopener" target="_blank" className="c-button  c-button--white  c-button--width-auto"><span>Book via venue</span></a>
                  ) : (
                    <a href={ticket.bookingLink} className="c-button  c-button--white  c-button--width-auto"><span>Book</span></a>
                  )}
                </div>
              ))}
            </li>
          ))}
        </ul>
      )}
  </div>
);

PerformanceDetails.propTypes = {
  title: PropTypes.string.isRequired,
  dates: PropTypes.string.isRequired,
  performanceList: PropTypes.arrayOf(PropTypes.shape({
    venue: PropTypes.string.isRequired,
    tickets: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  })),
};

PerformanceDetails.defaultProps = {
  performanceList: null,
};

export default PerformanceDetails;
